import { Action } from 'redux';
//Import States.
import {
    AdministratorState,
    AppState,
    EligibilityMessagePrioritiesState,
    getInitialEligibilityMessagePrioritiesState,
} from '@app/redux/states';
// Import Actions.
import {
    LoadEligibilityMessagePrioritiesAction,
    SelectEligibilityMessagePriorityAction,
} from '@app/redux/actions';
// Import api models.
import { EligibilityMessagePriorityWithId } from '@app/models/api';
// State initializers
import { initializeAdministratorState } from '@app/redux/reducers/initializers';
import { queryAdministratorState } from '@app/redux/reducers/queries';

/**
 * This handles initializing the state.
 * @param state
 */
const initializeState = (state: AppState): AppState => {
    let newState: AppState = { ...state };

    newState = initializeAdministratorState(newState);

    const administratorState: AdministratorState = queryAdministratorState(newState);

    if (!administratorState.eligibilityMessagePrioritiesState) {
        administratorState.eligibilityMessagePrioritiesState = getInitialEligibilityMessagePrioritiesState();
    }
    else {
        administratorState.eligibilityMessagePrioritiesState = { ...administratorState.eligibilityMessagePrioritiesState};
    }
    return newState;
};

/**
 * Query the state.
 * @param state
 */
const queryEligibilityMessagePrioritiesState = (state: AppState): EligibilityMessagePrioritiesState => {
    return queryAdministratorState(state).eligibilityMessagePrioritiesState;
};

//#region Load Eligibility Message Priorities
const LoadEligibilityMessagePrioritiesReducer = (state: AppState, action: Action): AppState => {
    const loadEligibilityMessagePrioritiesAction: LoadEligibilityMessagePrioritiesAction = action as LoadEligibilityMessagePrioritiesAction;
    const eligibilityMessagePriorities: EligibilityMessagePriorityWithId[] = loadEligibilityMessagePrioritiesAction.eligibilityMessagePriorities;
    const newState: AppState = initializeState(state);
    const eligibilityMessagePrioritiesState: EligibilityMessagePrioritiesState = queryEligibilityMessagePrioritiesState(newState);

    eligibilityMessagePrioritiesState.eligibilityMessagePriorities = eligibilityMessagePriorities;
    eligibilityMessagePrioritiesState.areEligibilityMessagePrioritiesLoaded = true;
    return newState;
};
//#endregion

//#region Select Eligibility Message Priority
const SelectEligibilityMessagePriorityReducer = (state: AppState, action: Action): AppState => {
    const selectEligibilityMessagePriorityAction: SelectEligibilityMessagePriorityAction = action as SelectEligibilityMessagePriorityAction;
    const eligibilityMessagePriorityId: string = selectEligibilityMessagePriorityAction.eligibilityMessagePriorityId;
    const newState: AppState = initializeState(state);
    const eligibilityMessagePrioritiesState: EligibilityMessagePrioritiesState = queryEligibilityMessagePrioritiesState(newState);

    eligibilityMessagePrioritiesState.selectedEligibilityMessagePriorityId = eligibilityMessagePriorityId;
    return newState;
};
//#endregion

//#region Unselect Eligibility Message Priority
const UnselectEligibilityMessagePriorityReducer = (state: AppState, action: Action): AppState => {
    const newState: AppState = initializeState(state);
    const eligibilityMessagePrioritiesState: EligibilityMessagePrioritiesState = queryEligibilityMessagePrioritiesState(newState);

    eligibilityMessagePrioritiesState.selectedEligibilityMessagePriorityId = undefined;
    return newState;
};
//#endregion

//#region Export reducers
export {
    LoadEligibilityMessagePrioritiesReducer,
    SelectEligibilityMessagePriorityReducer,
    UnselectEligibilityMessagePriorityReducer,
};
//#endregion

//#region Export initializer
export { initializeState };
//#endregion

//#region Export queries
export { queryEligibilityMessagePrioritiesState };
//#endregion